import { fetchPost } from '../Service/ApiService'

export const actionOfContentReview = (data,recordId,resolve, reject) => {
   

    try {
        fetchPost('contentreviewer/'+recordId+'/edit', data, {
            success: (res) => { resolve(res) },
            fail: (res) => { reject(res) },
            error: (err) => {
                reject({ status: false, message: "Unable to connect server" })
            }
        })
    } catch (e) {
        reject({ status: false, message: "Unable to process operation" })
    }
};









